import Vuex from 'vuex'

import { ActionContext, MutationTree, ActionTree, GetterTree } from "vuex"
import { TreeState } from './state'
import { TreeNode } from '../../model/models'
import { RootState } from "../state";

type Context = ActionContext<TreeState, RootState>;

function resetRootNode(node:TreeNode,url:string){
  node.label = 'root'
  node.url = url
  node.prefixId = url
  node.icon = 'remove'
  node.children =  []
  node.resolved = false
  node.collapsed = false
  node.isRoot = true
  node.isLeaf = false
}


let skostree:TreeNode = {
  label: 'root',
  url: 'root',
  prefixId: 'root',
  icon: 'fa fa-angle-down',
  children: [],
  resolved: false,
  collapsed: false,
  isRoot: true,
  isLeaf: false
}
let classtree:TreeNode = {
  label: 'root',
  url: 'root',
  prefixId: 'root',
  icon: 'fa fa-angle-down',
  children: [],
  resolved: false,
  collapsed: false,
  isRoot: true,
  isLeaf: false
}

const state: TreeState = {
  skosRoot : skostree,
  classRoot: classtree
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be rcorded by plugins
// for debugging purposes.
const mutations:MutationTree<TreeState> = {
  resetSkosRoot(state:TreeState, rootUrl:string){
    resetRootNode(state.skosRoot, rootUrl)
  },
  resetClassRoot(state:TreeState, rootUrl:string){
    resetRootNode(state.classRoot, rootUrl)
  },
  setSkosRootLabel(state:TreeState, label:string) { state.skosRoot.label = label},
  setClassRootLabel(state:TreeState, label:string) { state.classRoot.label = label}
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions:ActionTree<TreeState,any> = {
 
}
 
// getters are functions
const getters:GetterTree<TreeState,any> = {
  skosRoot: (state:TreeState) => { console.log('GET skosRoot'); return state.skosRoot },
  classRoot: (state:TreeState) => { console.log('GET classRoot'); return state.classRoot },
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export const treeStore = {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/tree/store.ts